export default {
      id: "ic_tribun_share_green-usage",
      viewBox: "0 0 18 20",
      url: "/" + "images/icons.3.109.2.svg#ic_tribun_share_green-usage",
      toString: function () {
        return this.url;
      }
    }